export default "__VITE_ASSET__DEhy4rHo__"